<template>
  <div class="wj_wrap">
    <div class="wj_container">
      <div class="search">
        <span class="lbl_title">合箱编码：</span>
        <el-input
          id="inputBox"
          v-model="boxNumber"
          autofocus
          ref="inputExpress"
          style="width: 500px"
          placeholder="请使用扫描枪或手动输入合箱编号，回车确认"
          :disabled="disable"
          clearable
          @clear="inputC()"
        ></el-input>
        <el-button
          style="
            margin-left: 20px;
            width: 120px;
            padding: 20px;
            border-radio: 10px;
          "
          @click="confirm()"
          type="primary"
          :loading="disable"
          >{{ disable ? "确认中" : "确认" }}</el-button
        >
      </div>
    </div>
    <!-- //表格 -->
    <div class="table_container">
      <div class="title">最近出库订单：</div>
      <el-table
        :data="historyList"
        border
        style="width: 100%"
        stripe
        row-key="boxId"
        max-height="550px"
        ref="table"
      >
        <el-table-column
          prop="boxNumber"
          label="合箱编码"
          align="center"
          width="180px"
        >
        </el-table-column>
        <el-table-column label="货物类型" align="center" width="120px">
          <template slot-scope="scope">
            <span class="tag" v-if="scope.row.goodType == 1"> 海运 </span>
            <span class="tag tag1" v-else-if="scope.row.goodType == 2">
              海运大件
            </span>
            <span class="tag tag3" v-else-if="scope.row.goodType == 3">
              空运
            </span>
          </template>
        </el-table-column>
        <el-table-column label="订单数量" align="center" width="120px">
          <template slot-scope="scope">
            {{ scope.row.orderCount }}
          </template>
        </el-table-column>
        <el-table-column label="用户VIP号" align="center" width="260px">
          <template slot-scope="scope">
            {{ scope.row.vipCodes }}
          </template>
        </el-table-column>
        <el-table-column label="派送点" align="left">
          <template slot-scope="scope">
            <h4>{{ scope.row.deliveryTitle }}</h4>
            {{ scope.row.address }}
          </template>
        </el-table-column>
        <el-table-column label="出库时间" align="center" width="180px">
          <template slot-scope="scope">
            {{
              scope.row.createTime
                ? toDate(scope.row.createTime, "yyyy-MM-dd hh:mm")
                : "时间未知"
            }}
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center" width="100px">
          <!-- <template slot-scope="scope">
            
          </template> -->
          <span style="color: #008b8b">已出库</span>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      :visible.sync="dialog.show"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="0px"
      height="0px"
      :modal="falseMark"
      :show-close="false"
      center
      @close="cancel()"
    >
      <div class="search_result" style="display:none">
        <div class="title">快递出库</div>
        <div class="main">
          <div class="tip_msg" v-if="msg">
            <el-alert :title="msg" type="error" :closable="false"></el-alert>
          </div>
          <el-form ref="form" size="mini">
            <div v-if="orderInfo" style="padding: 0 30px">
              <el-form-item label="合箱编码：">
                {{ orderInfo.boxNumber }}
              </el-form-item>
              <el-form-item label="用户：">
                {{ orderInfo.vipCodes }}
              </el-form-item>
              <el-form-item label="订单数量：">
                {{ orderInfo && orderInfo.orderCount }}
              </el-form-item>
              <el-form-item label="货物类型：">
                <span class="tag" v-if="orderInfo.goodType == 1"> 海运 </span>
                <span class="tag tag1" v-else-if="orderInfo.goodType == 2">
                  海运大件
                </span>
                <span class="tag tag3" v-else-if="orderInfo.goodType == 3">
                  空运
                </span>
              </el-form-item>
              <el-form-item label="派送点：">
                {{ orderInfo && orderInfo.deliveryTitle }}
              </el-form-item>
              <el-form-item label="状态：">
                <span class="tag tag4"> 未入库 </span>
              </el-form-item>
              <el-form-item label="时间：">
                <span v-if="orderInfo && orderInfo.createTime"
                  >{{
                    toDate(
                      orderInfo && orderInfo.createTime,
                      "yyyy-MM-dd hh:mm"
                    )
                  }}
                  <span class="tag tag2"> 合箱 </span>
                </span>
              </el-form-item>
              <el-form-item label="货柜号：" size="medium">
                <div class="l_item">
                  <el-input
                    style="width: 300px"
                    placeholder="输入货柜号"
                    v-model="viewDialog.boxContainerNumber"
                  ></el-input>
                  <span class="l_tip">（中转站出库可不填）</span>
                </div>
              </el-form-item>
              <el-form-item label="">
                <div class="order_detail">
                  <div style="text-align: center">
                    <span style="font-weight: bolder; font-size: 16px"
                      >订单清单</span
                    >
                  </div>
                  <div class="product_list">
                    <el-table
                      :data="datalist"
                      border
                      style="width: 100%"
                      stripe
                    >
                      <el-table-column
                        label="名称"
                        min-width="200px"
                        align="left"
                      >
                        <template slot-scope="scope">
                          {{ scope.row.productName }}
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="客户"
                        prop="realName"
                        min-width="70px"
                        align="center"
                      >
                        <template slot-scope="scope">
                          {{ scope.row.realName }}
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="vip号"
                        prop="vipCode"
                        min-width="60px"
                        align="center"
                      >
                        <template slot-scope="scope">
                          {{ scope.row.vipCode }}
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="物流公司"
                        prop="expressCompany"
                        min-width="80px"
                        align="center"
                      >
                      </el-table-column>
                      <el-table-column
                        label="运单号"
                        prop="expressNo"
                        min-width="125px"
                        align="left"
                      >
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="">
                <el-alert
                  title="按回车键出库，按ESC取消"
                  type="info"
                  :closable="false"
                ></el-alert>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="medium" @click="confirm()"
                  >出库</el-button
                >
                <el-button type="info" size="medium" @click="cancel()"
                  >取消</el-button
                >
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title="合箱出库"
      :visible.sync="isExistMark"
      width="30%"
      :modal="falseMark"
      :modal-append-to-body="false"
      align="left"
      :destroy-on-close="trueMark"
      @opened="openFail"
      @closed="closed"
    >
      <h1 style="color: #a30014; font-size: 24px; text-align: center">
        出库失败，系统无匹配运单。
      </h1>
      <div class="audioPar"></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isExistMark = false">取 消</el-button>
        <el-button type="primary" @click="isExistMark = false">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="isRepeatMark"
      width="30%"
      :modal="falseMark"
      :modal-append-to-body="false"
      align="center"
      :destroy-on-close="trueMark"
      @opened="openRepeat"
      :before-close="reHandleClose"
    >
      <h1 style="color: #a30014; font-size: 24px">
        合箱出库 &nbsp;({{ orderNum }})
      </h1>
      <br /><br /><br />
      <h1 style="color: #a30014; font-size: 24px">重复出库，本箱已被出库</h1>
      <div class="repeAudioPar"></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isRepeatMark = false">取 消</el-button>
        <el-button type="primary" @click="isRepeatMark = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="isPassMark"
      width="0px"
      height="0px"
      :modal="falseMark"
      :modal-append-to-body="false"
      align="center"
      :destroy-on-close="trueMark"
      :before-close="succHandleClose"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div style="display:none">
        <audio src="../../../static/audio/chukuSuccess.mp3" autoplay></audio>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isPassMark = false">取 消</el-button>
          <el-button type="primary" @click="isPassMark = false">确 定</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import * as date from "utils/date";
import * as boxApi from "@/api/box";
import * as deApi from "../../api/debounce";

export default {
  data() {
    let dataValidate = (rule, value, callback) => {
      if (!value) {
        let text;
        if (rule.field == "vipCode") text = "请输入VIP号";
        else if (rule.field == "expressCompany") text = "请选择物流公司";
        return callback(new Error(text));
      }
      return callback();
    };
    return {
      tableData: [],
      expressNo: "",
      orderInfo: [],
      disable: false,
      isSearch: false,
      boxNumber: "",
      datalist: [],
      historyList: [],
      viewDialog: {
        boxContainerNumber: "",
      },
      msg: "",
      dialog: {
        show: false,
      },
      expressList: [],
      orderDialog: {
        show: false,
        title: "补录信息",
        data: {
          vipCode: "",
          expressCompany: "",
        },
        form_rules: {
          vipCode: [
            {
              required: true,
              validator: dataValidate,
              trigger: "blur",
            },
          ],
          expressCompany: [
            {
              required: true,
              validator: dataValidate,
              trigger: "blur",
            },
          ],
        },
      },
      tobeIntoList: [],
      hasIntoList: [],
      isExistMark: false,
      isRepeatMark: false,
      isPassMark: false,
      orderNum: "",
      hasOutList:[],

      falseMark:false,
      trueMark:true
    };
  },
  created() {
    this.init();
    this.getBoxList();
    this.getTobeIntoStorList();
    this.getHasIntoStorList();
    this.getHasOutStorList();
  },

  watch:{
    boxNumber(){
      if(this.boxNumber.length == 16){
        this.confirm();
      }
      if(this.boxNumber.length > 16){
        this.boxNumber.slice(0,16);
      }
    }
  },

  methods: {
    init() {
      this.isSearch = null;
      this.dialog.show = false;
      this.viewDialog = "";
      this.orderInfo = [];
      this.msg = "";
      // this.getOrderList();
    },
    inputC() {
      // this.boxNumber = "";
    },
    async confirm() {
      //  if (this.isSearch) return;
      //  this.isSearch = true;
      if (this.boxNumber == "") return;
      if (this.dialog.show == false) {
        this.msg = "";
        let that = this;
        let param = {};
        param.pageIndex = 1;
        param.pageSize = 20;
        param.status = 7;
        param.goodType = null;
        param.boxNumber = that.boxNumber.replace(/\s/g, "");
        param.vipCode = "";
        param.deliveryTitle = "";
        if (that.boxNumber !== "") {
          await boxApi.boxList(param).then((res) => {
            if (res.status !== 200) {
              return that.$message.error("获取订单异常：" + res.msg);
            }
            if (res.data.code != 0) {
              return that.$message.error(res.data.msg || "获取合箱列表异常");
            }
            if (res.data.data.pageCount !== 0)
              that.orderInfo = res.data.data.list[0] || [];
          });
          if (
            that.orderInfo !== [] &&
            that.orderInfo.boxNumber == that.boxNumber.replace(/\s/g, "")
          ) {
            this.getBoxInfo();
          } else {
            let orderNum = this.boxNumber.trim();

            this.getTobeIntoStorList();
            this.getHasIntoStorList();
            this.getHasOutStorList();

            that.orderNum = orderNum;

            const ruleOne = (json) => json.boxNumber == orderNum;
            let resultOne = that.hasIntoList.some(ruleOne);


            const ruleTwo = (json) => json.boxNumber == orderNum;
            let resultTwo = that.hasOutList.some(ruleTwo);


            // 订单不存在
            if (!resultOne && !resultTwo) {
              that.isExistMark = true;
              that.boxNumber = "";
            }

            // 订单已入库
            if (!resultOne && resultTwo) {
              that.isRepeatMark = true;
              clearTimeout(timer);
              let timer = setTimeout(() => {
                that.isRepeatMark = false;
              }, 1200);
              that.boxNumber = "";
            }

            return;
          }
          this.dialog.show = true;
          clearTimeout(timer);
          let timer = setTimeout(()=>{
            this.confirm();
          },2000)
        }
      } else if (this.dialog.show) {
        this.dialog.show = false;
        this.submit();
      }
      this.dialog.show = true;
    },

    closed(){
      let inputDom = document.getElementById('inputBox');
      inputDom.focus();
    },

    // 获取中心仓库待入库数据
    getTobeIntoStorList() {
      let that = this;
      let param = {};
      param.pageIndex = "1";
      param.pageSize = "1000";
      param.status = "3";
      param.goodType = null;
      param.boxNumber = "";
      param.vipCode = "";
      param.deliveryTitle = "";
      boxApi.boxList(param).then((res) => {
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "获取合箱列表异常");
        }
        that.tobeIntoList = res.data.data.list || [];
      });
    },

    // 获取中心仓库已入库数据
    getHasIntoStorList() {
      let that = this;
      let param = {};
      param.pageIndex = "1";
      param.pageSize = "1000";
      param.status = "7";
      param.goodType = null;
      param.boxNumber = "";
      param.vipCode = "";
      param.deliveryTitle = "";
      boxApi.boxList(param).then((res) => {
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "获取合箱列表异常");
        }
        that.hasIntoList = res.data.data.list || [];
      });
    },

    // 获取中心仓库已出库数据
    getHasOutStorList() {
      let that = this;
      let param = {};
      param.pageIndex = "1";
      param.pageSize = "1000";
      param.status = "8";
      param.goodType = null;
      param.boxNumber = "";
      param.vipCode = "";
      param.deliveryTitle = "";
      boxApi.boxList(param).then((res) => {
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "获取合箱列表异常");
        }
        that.hasOutList = res.data.data.list || [];
        that.historyList = res.data.data.list || [];
        
      });
    },

    // handleClose(done) {},

    reHandleClose(done) {},
    succHandleClose(done) {},

    cancel() {
      this.init();
    },
    openFail(){
      let audioPar = document.getElementsByClassName("audioPar")[0];
      let audioDom = document.createElement("audio");
      audioDom.src = "../../../static/audio/chukuFail.mp3";
      audioDom.autoplay = "true";
      audioPar.appendChild(audioDom);
    },
    openRepeat(){
      let audioPar = document.getElementsByClassName("repeAudioPar")[0];
      let audioDom = document.createElement("audio");
      audioDom.src = "../../../static/audio/repeatChuku.mp3";
      audioDom.autoplay = "true";
      audioPar.appendChild(audioDom);
    },

    submit() {
      //分拨入库提交
      let that = this;
      let param = {};
      param.boxId = this.orderInfo.boxId;
      // param.status = 7;
      param.status = 8;

      param.type = 1;
      param.boxContainerNumber = that.viewDialog.boxContainerNumber;
      if (that.dialog.show == false) {
        const loading = this.$loading({
          lock: true,
          text: "loading",
          spinner: "el-icon-loading",
          background: "rgba(0,0,0,0.7)",
        });

        boxApi.boxDelivery(param).then((res) => {

          loading.close();
          if (res.data.code != 0) {
            return that.$message.error(res.data.msg || "操作异常");
          }
          that.$message({
            message: "出库成功!",
            type: "success",
          });

          that.isPassMark = true;

          clearTimeout(timers);
          let timers = setTimeout(() => {
            that.isPassMark = false;
          }, 0);

          this.getBoxList();
          that.boxNumber = "";
          that.cancel();

          this.getTobeIntoStorList();
          this.getHasIntoStorList();
          this.getHasOutStorList();
        });
      }
    },
    getBoxInfo() {
      let that = this;
      let param = {};
      param.boxId = that.orderInfo.boxId;
      boxApi.allocationCentreInformation(param).then((res) => {
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "获取合箱列表异常");
        }
        that.datalist = res.data.data.orderPojoList;
      });
    },
    toDate(time, fmt) {
      if (!time) return "";
      return date.formatDate(new Date(time), fmt);
    },
    
    getBoxList() {
      let that = this;
      let param = {};
      param.pageIndex = 1;
      param.pageSize = 10;
      param.status = 7;
      param.goodType = "";
      param.boxNumber = "";
      param.vipCode = "";
      param.deliveryTitle = "";
      boxApi.boxList(param).then((res) => {
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "获取合箱列表异常");
        }
      });
    },
  },
  mounted() {
    // 添加键盘Esc事件
    document.getElementById("inputBox").addEventListener(
      "keydown",
      deApi.debounce(
        (e) => {
          if (e.keyCode == 27) {
            this.cancel();
          } else if (e.keyCode == 13) {
            this.confirm();
            // }
          }
        },
        300,
        true
      )
    );
    // this.isSearch=true
  },
  destroyed() {
    // document.removeEventListener("keydown", deApi.debounce());
  },
};
</script>
<style  lang="less" scoped>
.wj_wrap {
  padding-bottom: 50px;
  .wj_container {
    width: 800px;
    margin: 50px auto;
    .search {
      .lbl_title {
        font-size: 24px;
        font-weight: bold;
      }
    }
  }

  .tip_msg {
    margin-left: 20px;
    text-align: center;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .no_data {
    margin-top: 30px;
  }
  .search_result {
    min-height: 300px;
    .title {
      font-size: 24px;
      font-weight: bold;
      margin-left: 20px;
    }
    .main {
      margin-top: 20px;
    }
  }
  .tag {
    display: inline-block;
    padding: 3px 5px;
    border-radius: 4px;
    background-color: #f4f4f5;
    border-color: #e9e9eb;
    color: #909399;
    &.tag1 {
      background-color: #ecf5ff;
      color: #409eff;
      border: 1px solid #d9ecff;
    }
    &.tag2 {
      background-color: #f0f9eb;
      border-color: #e1f3d8;
      color: #67c23a;
    }
    &.tag3 {
      background-color: #fdf6ec;
      border-color: #faecd8;
      color: #e6a23c;
    }
    &.tag4 {
      background-color: #fdf6ec;
      border-color: #fadfd8;
      color: #e6423c;
    }
  }
  .table_container {
    width: 85%;
    margin: 0 auto;
    .title {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 10px;
    }
    .sign {
      font-size: 12px;
      color: #e6a23c;
    }
  }
}
</style>
<style lang="less">
.wj_container {
  .search {
    .el-input__inner {
      height: 60px;
      line-height: 60px;
      border-radius: 10px;
    }
  }
}
.search_result {
  .el-alert__title {
    font-size: 18px;
  }
  .el-button--medium {
    padding: 10px 40px;
  }
  .el-form-item__label {
    font-size: 18px;
    font-weight: bold;
  }
  .el-form-item__content {
    font-size: 18px;
  }
  .el-form-item--mini.el-form-item,
  .el-form-item--small.el-form-item {
    margin: 15px 0;
  }
}
// .closeDia{
//   width:100px;
//   height:100px;
// }
</style>

<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0;
}
</style>


// WEBPACK FOOTER //
// outStorage.vue?99013784